import { render, staticRenderFns } from "./ProductIntroXiaofangshu.vue?vue&type=template&id=1c430638&scoped=true&"
import script from "./ProductIntroXiaofangshu.vue?vue&type=script&lang=js&"
export * from "./ProductIntroXiaofangshu.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroXiaofangshu.vue?vue&type=style&index=0&id=1c430638&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c430638",
  null
  
)

export default component.exports